module.exports = {
	"id": "NU",
	"name": "Niue",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.258848,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 2.353899,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": null,
			"44": null,
			"45": null,
			"46": null,
			"47": 1.043481,
			"48": null,
			"49": 10.467166,
			"50": null,
			"51": 0.784633,
			"52": 1.836203,
			"53": 15.967686,
			"54": 7.595571,
			"55": null,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.258848,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": 1.310418,
			"43": null,
			"44": null,
			"45": null,
			"46": null,
			"47": 1.836203,
			"48": 4.974735,
			"49": 6.285153,
			"50": 1.310418,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.258848,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": 1.310418,
			"39": 0.258848,
			"40": 0.784633,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": 1.310418,
			"3.1": null,
			"3.2": null,
			"5.1": null,
			"6.1": null,
			"7.1": null,
			"9.1": null
		},
		"ios_saf": {
			"8": 0,
			"10": 0,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0,
			"8.1-8.4": 0,
			"9.0-9.2": 0,
			"9.3": 0
		},
		"android": {
			"3": 0,
			"4": 0.0518488372093,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00648110465116,
			"4.1": 0.187026162791,
			"4.2-4.3": 0.467565406977,
			"4.4": 1.07215988372,
			"4.4.3-4.4.4": 1.08141860465
		},
		"ie": {
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 19.890851,
			"5.5": null
		},
		"op_mob": {
			"0": 0,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0
		},
		"edge": {
			"12": null,
			"13": null,
			"14": null
		},
		"ie_mob": {
			"10": 0.188408450704,
			"11": 0.767091549296
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 1.911
		},
		"and_uc": {
			"0": 0.9555
		},
		"op_mini": {
			"0": 0
		},
		"and_chr": {
			"0": 12.680348
		},
		"and_ff": {
			"0": null
		}
	},
	"total": 99.466126
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/NU.json
 ** module id = 614
 ** module chunks = 0
 **/